/**
 * Import as `devConsole` and use the functions like you would use
 * `console.log` etc
 *
 * ```
 * import * as devConsole from '../dev-console';
 * devConsole.log('This will not be printed in prod');
 * ```
 */

import { isDev } from './helpers';

type ConsoleFunc = (...args: any[]) => void;

function wrap(f: ConsoleFunc): ConsoleFunc {
  return (...args) => {
    if (isDev) {
      f.apply(console, args);
    }
  };
}

// eslint-disable-next-line no-console
export const log: ConsoleFunc = wrap(console.log);
export const warn: ConsoleFunc = wrap(console.warn);
export const error: ConsoleFunc = wrap(console.error);
